import { Store } from 'redux';
import { Maybe } from 'Utils/types/utility';
import { trackUniversalAnalyticsSessionInit } from '../../../client/redux/tracking/actions';
import StateInterface, { BellaThunkDispatch } from '../../../client/redux/types';
import { DataLayerManagerInterface, UserSessionInfo } from '../types';

// eslint-disable-next-line complexity
export const updateDataLayer = (
    dataLayerManager: DataLayerManagerInterface,
    { appShellLogin, tracking }: StateInterface,
    dispatch: BellaThunkDispatch<Promise<void>>
) => {
    const { data, isLoggedIn } = appShellLogin;
    if (data) {
        let userInfo: Maybe<UserSessionInfo> = null;
        const isUserSet = dataLayerManager.getDataLayer().some(el => el['user-id'] === (data && data.id));
        if (isLoggedIn && !isUserSet) {
            userInfo = {
                'user-id': data.id || '',
                'user-name': data.firstName || '',
                'user-email': data.email || '',
                'user-createdAt': data.registeredAt || '',
                'user-hashed-mail': data.hashedEmail || '',
                'hashed-user-id': data.hashedId || '',
                'user-login_check': '1',
            };
        }

        if (!tracking.universalAnalyticsSessionInitDidFire) {
            dataLayerManager.initUserSession(userInfo);
            dispatch(trackUniversalAnalyticsSessionInit);
        }
    }
};

export const connectToStore = (dataLayerManager: DataLayerManagerInterface, store: Store) => {
    store.subscribe(() => updateDataLayer(dataLayerManager, store.getState(), store.dispatch));
};

export default {
    connect: connectToStore,
};
